import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTranslation } from 'react-i18next';

import { TOKENS, hmShort } from '../worktimeLib';

/**
 * P-watchdog (§9): the polled session carries needs_review (the periodic watchdog flagged it
 * as running too long). "Continue" only suppresses the nag on THIS device (localStorage) —
 * needs_review stays set server-side for reconciliation/foreman, and the server watchdog is the
 * real safety net. NOTE (known limitation, not a bug): this ack is device-local — it re-nags on
 * other devices and stays silenced even as the session keeps growing (13h→18h). A future move of
 * the ack to the backend is planned.
 */
export default function PWatchdogDialog({ open, durationSeconds, onContinue, onStop, busy }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '10px',
            backgroundColor: TOKENS.redSoft,
            color: TOKENS.red,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ReportProblemIcon fontSize="small" />
        </Box>
        {t('worktime.watchdog.title', { duration: hmShort(durationSeconds, t) })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t('worktime.watchdog.body')}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, gap: 1, flexDirection: 'column', alignItems: 'stretch' }}>
        <Button
          onClick={onContinue}
          variant="contained"
          disabled={busy}
          fullWidth
          sx={{ backgroundColor: TOKENS.green, '&:hover': { backgroundColor: TOKENS.greenDark } }}
        >
          {t('worktime.watchdog.continue')}
        </Button>
        <Button onClick={onStop} variant="outlined" disabled={busy} fullWidth>
          {t('worktime.watchdog.stopAndFix')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
